import React from 'react';
import { Lightbulb } from 'lucide-react';

interface RunSuggestionInsightsProps {
  reasoning: string;
  coaching_tips?: string[];
  focus_areas?: string[];
  alternatives?: {
    if_tired?: string;
    if_energetic?: string;
  };
}

const RunSuggestionInsightsInner: React.FC<RunSuggestionInsightsProps> = ({
  reasoning,
  coaching_tips,
  focus_areas,
  alternatives
}) => {
  return (
    <div className="space-y-6">
      {/* Reasoning */}
      <div>
        <h4 className="font-medium text-sm mb-2 flex items-center gap-2">
          <Lightbulb className="h-4 w-4 text-yellow-500" />
          Why This Run?
        </h4>
        <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded-md">
          {reasoning}
        </p>
      </div>

      {/* Focus Areas */}
      {focus_areas && focus_areas.length > 0 && (
        <div>
          <h4 className="font-medium text-sm mb-2">Focus Areas</h4>
          <div className="space-y-1 text-sm text-gray-600">
            {focus_areas.map((area: string, index: number) => (
              <div key={index} className="flex items-start gap-2">
                <div className="w-1.5 h-1.5 bg-purple-500 rounded-full mt-2 flex-shrink-0"></div>
                <span>{area}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Coaching Tips */}
      {coaching_tips && coaching_tips.length > 0 && (
        <div>
          <h4 className="font-medium text-sm mb-2">Coaching Tips</h4>
          <div className="space-y-2">
            {coaching_tips.map((tip: string, index: number) => (
              <div key={index} className="text-sm text-gray-600 bg-blue-50 p-2 rounded border-l-2 border-blue-200">
                💡 {tip}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Alternatives */}
      {alternatives && Object.keys(alternatives).length > 0 && (
        <div>
          <h4 className="font-medium text-sm mb-2">Alternatives</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
            {'if_tired' in alternatives && alternatives.if_tired && (
              <div className="bg-orange-50 p-3 rounded-md border border-orange-200">
                <span className="font-medium text-orange-800">If feeling tired:</span>
                <p className="text-orange-700 mt-1">{String(alternatives.if_tired)}</p>
              </div>
            )}
            {'if_energetic' in alternatives && alternatives.if_energetic && (
              <div className="bg-green-50 p-3 rounded-md border border-green-200">
                <span className="font-medium text-green-800">If feeling great:</span>
                <p className="text-green-700 mt-1">{String(alternatives.if_energetic)}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export const RunSuggestionInsights = React.memo(RunSuggestionInsightsInner);